<template>
    <div class="card-container agentmanage">
        <common-top-form :model="formModel" :submitService="submitService" @reset="reset" :show="false" :needReset="true"
                         :submitData="submitData" @success="onSuccess">
                <select-organs v-model="formModel.tatSimpleId" :selectValue="formModel.tatSimpleId"></select-organs>
                <el-form-item label="身份证号" prop="cardNo">
                    <el-input type="text" maxlength="50" v-model="formModel.idCard" placeholder="请输入身份证号"></el-input>
                </el-form-item>
                <el-form-item label="电话号码" prop="phone">
                    <el-input type="text" maxlength="50" v-model="formModel.phone" placeholder="请输入电话号码"></el-input>
                </el-form-item>
        </common-top-form>
        <common-table :data="tableData" ref="commonTable" @handleChange="getPage"  v-loading="loading">
            <el-table-column type="index" min-width="80" label="序号"></el-table-column>
            <el-table-column prop="tatName" label="机构简称" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="realName" label="姓名" min-width="100" show-overflow-tooltip></el-table-column>
            <el-table-column prop="phoneNumber" label="电话" min-width="130" show-overflow-tooltip></el-table-column>
            <el-table-column prop="idCard" label="身份证号码" min-width="160" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" min-width="100">
                <template slot-scope="scope">
                    <el-button type="text" @click="handleDetail(scope.row.id,scope.row.realName,scope.row.phoneNumber,)">详情</el-button>
                </template>
            </el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonTopForm from 'components/common/CommonTopForm'
    import CommonTable from 'components/common/CommonTable'
    import OrganService from 'service/OrganService'
    import SelectOrgans from 'components/business/SelectOrgans'
    import TransactionService from 'service/TransactionService'
    import ChannelService from 'service/ChannelService'
    import privateKey from 'service/constant/privateKey'
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin,dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'
    export default {
        name: "testimonydata",
        data() {
            return {
                formModel:{
                    tatSimpleId:'',
                    phone:'',
                    idCard:'',
                },
                tableData:[],
                submitService:TransactionService.ocrAuthGetList,
                page:{},
                isPage:false,
                loading:false,
            }
        },
        mixins:[loadMixin,dialogMixin],
        components: {
            CommonTopForm ,
            CommonTable,
            SelectOrgans,
        },
        mounted(){
            this.page = this.$refs.commonTable.page;
        },
        computed: {
            submitData() {
                const params = {
                    tatSimpleId: this.formModel.tatSimpleId,
                    phone: this.formModel.phone.trim(),
                    idCard: this.formModel.idCard.trim(),

                    current: this.isPage ? this.page.currentPage : 1,
                    size: this.page.pageSize,
                };

                return params;
            },
            ...mapGetters(['serverType','tatId','userId'])
        },
        methods: {
            reset(){
                this.formModel = {
                    tatSimpleId:'',
                    idCard:'',
                    phone:'',
                };
                this.getList();
            },
            getPage(){
                this.isPage = true;
                this.getList();
            },
            getList() {
                this.doLoad(this.submitService,this.submitData,res => {
                    this.doCheck(res,res =>{
                        const result = res.contents;
                        this.tableData = result.rows;

                        this.page.currentPage = result.current;
                        this.page.total = result.total;
                        this.page.pageSize = result.size;
                        this.isPage = false;
                    });
                },'信息获取失败')
            },
            onSuccess(data) {
                this.doCheck(data,res => {
                    const result = res.contents;
                    this.tableData = result.rows;
                    this.page.currentPage = result.current;
                    this.page.total = result.total;
                    this.page.pageSize = result.size;
                })
            },
            handleDetail(id, name, phone){
                this.$router.push({
                    name:'testimoneydetails',
                    params:{
                        id:id,
                        name: name,
                        phone: phone
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .detail-box p{
        font-size: 14px;
        color: #000;
        line-height: 2;
    }
    .detail-box p span{
        font-weight: 700;
        display: inline-block;
        width: 6em;
        letter-spacing: 0.13em;
        margin-right: -0.13em;
    }
    .detail-box p span.three{
        letter-spacing: 0.5em;
        margin-right: -0.5em;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/ToolsManage/TestimonyData.vue